export default __webpack_public_path__ + "static/media/classic.01cbba4b.webp";